"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rangeHelper_1 = __importDefault(require("../components/parts/Head/rangeHelper"));
function genDefaultZoomButtons(toTime, fromTime) {
    var buttons = [];
    var timeInMS = {
        year: rangeHelper_1.default('year', 1),
        month: rangeHelper_1.default('month', 1),
        week: rangeHelper_1.default('week', 1),
        day: rangeHelper_1.default('day', 1),
        hour: rangeHelper_1.default('hour', 1),
        millisecond: rangeHelper_1.default('millisecond', 1),
    };
    var yearButton = { type: 'year', text: 'Year', count: 1 };
    var monthButton = { type: 'month', text: 'Month', count: 1 };
    var biWeekButton = { type: 'week', text: 'Bi-weekly', count: 2 };
    var weekButton = { type: 'week', text: 'Week', count: 1 };
    var threeDayButton = { type: 'day', text: '3 Day', count: 3 };
    var dayButton = { type: 'day', text: 'Day', count: 1 };
    var twelveHourButton = { type: 'hour', text: '12 Hour', count: 12 };
    var sixHourButton = { type: 'hour', text: '6 Hour', count: 6 };
    var hourButton = { type: 'hour', text: 'Hour', count: 1 };
    var thirtyMinButton = { type: 'minute', text: '30 Minute', count: 30 };
    var fiftenMinButton = { type: 'minute', text: '15 Minute', count: 15 };
    var minButton = { type: 'minute', text: 'Minute', count: 1 };
    var ytdButton = { type: 'ytd', text: 'YTD' };
    var allButton = { type: 'all', text: 'All' };
    var difference = toTime - fromTime;
    var unit = Object.entries(timeInMS).find(function (_a) {
        var key = _a[0], value = _a[1];
        return difference > value;
    })[0];
    switch (unit) {
        case 'year':
            buttons.push(yearButton);
            buttons.push(monthButton);
            buttons.push(ytdButton);
            buttons.push(allButton);
            break;
        case 'month':
            buttons.push(dayButton);
            buttons.push(weekButton);
            buttons.push(biWeekButton);
            buttons.push(monthButton);
            buttons.push(allButton);
            break;
        case 'week':
            buttons.push(weekButton);
            buttons.push(threeDayButton);
            buttons.push(dayButton);
            buttons.push(allButton);
            break;
        case 'day':
            buttons.push(dayButton);
            buttons.push(twelveHourButton);
            buttons.push(sixHourButton);
            buttons.push(allButton);
            break;
        case 'hour':
            buttons.push(hourButton);
            buttons.push(thirtyMinButton);
            buttons.push(fiftenMinButton);
            buttons.push(minButton);
            buttons.push(allButton);
            break;
        default:
            buttons.push(allButton);
    }
    return buttons;
}
exports.default = genDefaultZoomButtons;
//# sourceMappingURL=genDefaultZoomButtons.js.map